module.exports = __webpack_public_path__ + "img/banner-xl1.744bb3fa.webp";